import React, { useState, useEffect } from "react";
import axios from "axios";

const TableFour4 = props => {
  const API = props.API;
  const [XS, setXS] = useState([0, 0, 0]);
  const [YS, setYS] = useState([0, 0, 0]);
  const [ZS, setZS] = useState([0, 0, 0]);

  const [editable, setEditable] = useState(false);

  const submitForm = data => {
    var settings = {
      url: API + "/sectionfourfour-create",
      method: "POST",
      headers: {
        "Content-Type": "application/json"
      },
      data: {
        xs: data.xs,
        ys: data.ys,
        zs: data.zs,
        avgapis: data.avgapis,
        apis: data.apis
      }
    };

    axios(settings)
      .then(res => {
        console.log("Database Stored");
        console.log(res.data);
      })
      .catch(err => {
        console.log(err);
      });
  };

  useEffect(() => {
    var settings = {
      url: API + "/sectionfourfour-get",
      method: "GET",
      headers: {
        "Content-Type": "application/json"
      }
    };

    axios(settings)
      .then(res => {
        let xs = res.data.xs;
        let ys = res.data.ys;
        let zs = res.data.zs;

        xs.length === 0 ? setXS([0, 0, 0]) : setXS(xs);
        ys.length === 0 ? setYS([0, 0, 0]) : setYS(ys);
        zs.length === 0 ? setZS([0, 0, 0]) : setZS(zs);
      })
      .catch(err => {
        console.log(err);
      });
  }, []);


  const changeData = (type, val, index, previousData) => {
    val = Number(val);

    switch (type) {
      case "XS":
        if (index === 0) setXS([val, previousData[1], previousData[2]]);
        if (index === 1) setXS([previousData[0], val, previousData[2]]);
        if (index === 2) setXS([previousData[0], previousData[1], val]);
        break;
      case "YS":
        if (index === 0) setYS([val, previousData[1], previousData[2]]);
        if (index === 1) setYS([previousData[0], val, previousData[2]]);
        if (index === 2) setYS([previousData[0], previousData[1], val]);
        break;
      case "ZS":
        if (index === 0) setZS([val, previousData[1], previousData[2]]);
        if (index === 1) setZS([previousData[0], val, previousData[2]]);
        if (index === 2) setZS([previousData[0], previousData[1], val]);
        break;
      default:
        console.log("Default");
    }
  };

  return (
    <div>
      <h2>4.4. Academic Performance in Second Year (15)</h2>
      <p>
        Academic Performance Level = 1.5 * Average API (Academic Performance
        Index) <br />
        <b>API</b> = ((Mean of 2nd Year Grade Point Average of all successful
        Students on a 10 point scale) or (Mean of the percentage of marks of all
        successful students in Second Year/10)) x (number of successful
        students/number of students appeared in the examination) <br />
        Successful students are those who are permitted to proceed to the Third
        year.
      </p>
      <table border="1" cellPadding="10" width="80%">
        <tbody>
          {/* Heading */}
          <tr>
            <th>Academic Performance</th>
            <th>
              CAYm1 <br /> (2016-2017)
            </th>
            <th>
              CAYm2 <br /> (2015-2016)
            </th>
            <th>
              CAYm3 <br /> (2014-2015)
            </th>
          </tr>

          {/* XS */}
          <tr>
            <td>
              Mean of CGPA or Mean Percentage of all successful students (X)
            </td>
            {XS.map((d, index) => {
              if (editable)
                return (
                  <td key={index}>
                    <input
                      type="number"
                      value={d}
                      onChange={e =>
                        changeData("XS", e.target.value, index, [
                          XS[0],
                          XS[1],
                          XS[2]
                        ])
                      }
                    />
                  </td>
                );
              else return <td key={index}>{d}</td>;
            })}
          </tr>

          {/* YS */}
          <tr>
            <td>Total no. of successful students (Y)</td>
            {YS.map((d, index) => {
              if (editable)
                return (
                  <td key={index}>
                    <input
                      type="number"
                      value={d}
                      onChange={e =>
                        changeData("YS", e.target.value, index, [
                          YS[0],
                          YS[1],
                          YS[2]
                        ])
                      }
                    />
                  </td>
                );
              else return <td key={index}>{d}</td>;
            })}
          </tr>

          {/* ZS */}
          <tr>
            <td>Total no. of students appeared in the examination (Z)</td>
            {ZS.map((d, index) => {
              if (editable)
                return (
                  <td key={index}>
                    <input
                      type="number"
                      value={d}
                      onChange={e =>
                        changeData("Z", e.target.value, index, [
                          ZS[0],
                          ZS[1],
                          ZS[2]
                        ])
                      }
                    />
                  </td>
                );
              else return <td key={index}>{d}</td>;
            })}
          </tr>

          {/* APIS */}
          <tr>
            <td>API = x* (Y/Z)</td>
            <td>{Math.trunc((YS[0] / ZS[0]) * XS[0]).toString()}</td>
            <td>{Math.trunc((YS[1] / ZS[1]) * XS[1]).toString()}</td>
            <td>{Math.trunc((YS[2] / ZS[2]) * XS[2]).toString()}</td>
          </tr>

          {/* AVGAPIS */}
          <tr>
            <td>Average API = (AP1 + AP2 + AP3)/3</td>
            <td colSpan="3">
              {Math.trunc(
                (Math.trunc((YS[0] / ZS[0]) * XS[0]) +
                  Math.trunc((YS[1] / ZS[1]) * XS[1]) +
                  Math.trunc((YS[2] / ZS[2]) * XS[2])) /
                  3
              ).toString()}
            </td>
          </tr>
        </tbody>
      </table>
      {editable ? null : (
        <button onClick={() => setEditable(true)}>Edit</button>
      )}
      &nbsp;
      <button
        onClick={() => {
          setEditable(false);

          var data = {
            xs : XS,
            ys : YS,
            zs : ZS,
            apis: [
              Math.trunc((YS[0] / ZS[0]) * XS[0]),
              Math.trunc((YS[1] / ZS[1]) * XS[1]),
              Math.trunc((YS[2] / ZS[2]) * XS[2])
            ],
            avgapis: Math.trunc(
              (Math.trunc((YS[0] / ZS[0]) * XS[0]) +
                Math.trunc((YS[1] / ZS[1]) * XS[1]) +
                Math.trunc((YS[2] / ZS[2]) * XS[2])) /
                3
            )
          };
          console.log(data);
          submitForm(data);
        }}
      >
        Submit
      </button>
    </div>
  );
};

export default TableFour4;
